import axios from "@/libs/api.request";
import config from "@/config";
import { paramFormat } from "@/api/fn";
import { getToken } from "@/libs/util";
const baseUrl =
  process.env.NODE_ENV === "development"
    ? config.baseUrl.dev
    : config.baseUrl.pro;

export default {
  queryPointList(data) {
    let token = getToken();
    let param = paramFormat(data);
    return axios.request({
      url: baseUrl + "/sys/point/queryPointList",
      data: param,
      dataType: "json",
      headers: {
        token: token,
        "Content-Type": "application/json; charset=utf-8"
      },
      method: "POST"
    });
  },
  queryPointByFilter(data) {
    let token = getToken();
    let param = paramFormat(data);
    return axios.request({
      url: baseUrl + "/sys/point/queryPointByFilter",
      data: param,
      dataType: "json",
      headers: {
        token: token,
        "Content-Type": "application/json; charset=utf-8"
      },
      method: "POST"
    });
  },
  newPoint(data) {
    let token = getToken();
    let param = paramFormat(data);
    return axios.request({
      url: baseUrl + "/sys/point/newPoint",
      data: param,
      dataType: "json",
      headers: {
        token: token,
        "Content-Type": "application/json; charset=utf-8"
      },
      method: "POST"
    });
  },
  updatePointById(data) {
    let token = getToken();
    let param = paramFormat(data);
    return axios.request({
      url: baseUrl + "/sys/point/updatePointById",
      data: param,
      responseType: 'json',
      dataType: "json",
      headers: {
        token: token,
        "Content-Type": "application/json; charset=utf-8"
      },
      method: "POST"
    });
  },
  deletePointById(data) {
    let token = getToken();
    let param = paramFormat(data);
    return axios.request({
      url: baseUrl + "/sys/point/deletePointById",
      data: param,
      dataType: "json",
      headers: {
        token: token,
        "Content-Type": "application/json; charset=utf-8"
      },
      method: "POST"
    });
  },
  queryPointById(data) {
    let token = getToken();
    let param = { "id": data.id };
    let url = baseUrl + "/sys/point/queryPointById/" + param.id;
    return axios.request({
      url: url,
      dataType: "json",
      async: false,
      headers: {
        token: token,
        "Content-Type": "application/json; charset=utf-8"
      },
      method: "GET"
    });
  }
};
